// extracted by mini-css-extract-plugin
export default {"wb":"styles_wb__mLbrs","page-title":"styles_page-title__L+ol1","section":"styles_section__S1O4x"};